<template>
<router-view />
</template>

<script>
export default {
  name: 'DataDisplayVOCsPhotochemical',
  routeInfo: {
    label: '光化学',
    icon: 'fa fa-users'
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/03Data-Display/02VOCs-Photochemical/index.vue